<template>
  <div class="panier-component mt-15">
    <div class="columns has-background-white">
      <div class="column is-narrow column-img ml-40 mr-12">
        <img v-if="reseau.urlPhoto"
            class="image tailleImage"
            :src="reseau.urlPhoto">
        <img v-else class="image tailleImage" src="@/assets/default-placeholder.png"/>
        <p class="has-text-weight-bold has-text-dark is-size-6 champReseau">
          Réseau : <span>{{reseau.libelle}}</span>
        </p>
        <p>Nb d'écrans :
          {{reseau.nbFaces}}
        </p>
        <b-modal v-model="isComponentDetailReseaux"
                  has-modal-card
                  class="modal">
                <info-window-reseaux :reseau ="reseau"/>
          </b-modal>
        <a class="plusInfo" @click="isComponentDetailReseaux = !isComponentDetailReseaux">
          Plus d'informations sur le réseau
        </a>
      </div>
      <div class="column columns">
        <div class="column is-paddingless is-two-quarter">
          <div class="column is-12 p-5px">
            <div class="control">
              <label class="subtitle">Tarification</label>
                <b-select v-model="reseau.extensionOpportunite.typeTarification"
                  expanded :disabled="disabled">
                <option :key="tarif.value" :value="tarif.value" v-for="tarif in tarifications" >
                  {{tarif.libelle}}
                </option>
                </b-select>
            </div>
          </div>
          <div class="column is-12 p-5px">
            <b-field grouped>
              <b-field label="Tarif HT" class="mb-0" custom-class="mb-0 label-color" expanded>
                <input-currency v-model="reseau.tarifBrut"
                                isNumber="true"
                                :disabled="disabled"/>
              </b-field>
              <b-field label="/an , /mois…" class="mb-0" custom-class="mb-0 label-color" expanded>
                <b-input v-model="reseau.extensionOpportunite.tarifInformation"
                               :disabled="disabled"/>
              </b-field>
            </b-field>
          </div>
          <div class="column is-12 p-5px">
            <div class="control">
              <label class="subtitle">Taxes municipales / TLPE</label>
              <input-currency v-model="reseau.extensionOpportunite.taxeMunicipale"
                              :disabled="disabled">
              </input-currency>
            </div>
            Montant TLPE pour la durée de location
          </div>
        </div>
        <div class="column is-paddingless is-two-quarter">
          <div class="column is-12 p-5px">

              <b-field label="Remise" class="mb-0" custom-class="mb-0 label-color" expanded>
                <b-field>
                  <input-currency v-model="reseau.extensionOpportunite.remise"
                                  isNumber="true"
                                  @input="onRemiseChange"
                                  :disabled="disabled"/>
                  <b-select
                    v-model="reseau.extensionOpportunite.typeDeRemise"
                    placeholder="0"
                    :disabled="disabled">
                    <option :value="0">%-</option>
                    <option :value="1">€</option>
                  </b-select>
                </b-field>
              </b-field>


          </div>
           <div class="column is-12 p-5px">
              <b-field label="Quantité" class="mb-0" custom-class="mb-0 label-color" expanded>
                <input class="input"
                    type="number"
                    v-model="reseau.extensionOpportunite.quantite"
                    :disabled="disabled">
              </b-field>
           </div>
          <div class="column is-12 p-5px">
            <div class="control">
              <label class="subtitle">Tarif Net</label>
              <input-currency
                :value="reseau.extensionOpportunite.tarifNet"
                isNumber="true"
                :disabled="disabled"
                @input="changeTarifNet($event, true)">
              </input-currency>
            </div>
          </div>
          <div class="column is-12 p-5px">
            <div class="control">
              <label class="subtitle">Frais adserving</label>
              <input class="input"
                    type="number"
                    v-model.number="reseau.extensionOpportunite.fraisAdserving"
                    :disabled="disabled">
            </div>
          </div>
        </div>
        <div class="column is-paddingless is-one-quarter">
          <div class="column is-12 p-5px">
            <div class="control">
              <label class="subtitle">Spots pub</label>
              <input class="input"
                    type="number"
                    v-model="reseau.extensionOpportunite.spotsPub"
                    :disabled="disabled">
            </div>
          </div>
          <div class="column is-12 p-5px">
            <label class="subtitle">Diffusions / jour</label>
            <input class="input"
                    type="number"
                    v-model="reseau.extensionOpportunite.nbDiffusion"
                    :disabled="disabled">
          </div>
          <div class="column is-12 p-5px">
            <b-field label="Commentaire" custom-class="mb-0 label-color">
              <b-input
                type="textarea"
                rows="2"
                v-model="reseau.extensionOpportunite.commentaire"
                :disabled="disabled"/>
            </b-field>
          </div>
        </div>
        </div>
        <div class="column is-3 is-paddingless mr-20">
          <div class="is-flex flex-align-center-justify-end p-5px">
            <p class="has-text-weight-bold is-size-6 has-text-black mr-12">
              {{reseau.prixTotal}} €
            </p>
            <a @click="suppressionPanneau">
              <b-icon icon="delete-forever" type="is-danger"/>
            </a>
          </div>
          <div class="column is-12 has-background-color-background">
            <span class="mb-0 label-color has-text-weight-bold p-5px">Editions</span>
            <div class="column is-12 p-5px">
              <article class="media">
                <div class="media-left">
                  <button class="button"
                        v-bind:class="[reseau.extensionOpportunite.masquerFaceEdition ?
                        'is-primary' : 'is-grey']"
                        :disabled="disabled"
                        @click="reseau.extensionOpportunite.masquerFaceEdition =
                        !reseau.extensionOpportunite.masquerFaceEdition">
                        <b-icon icon="eye-off"
                            :type="reseau.extensionOpportunite.masquerFaceEdition ?
                              'is-white' : 'is-grey'"/>
                  </button>
                </div>
                <div class="media-content is-paddingless">
                  <div class="content has-text-weight-semibold">
                    Masquer les faces sur l'édition
                  </div>
                </div>
              </article>
            </div>
          <div class="column is-12 p-5px">
            <article class="media">
              <div class="media-left">
                <button
                  class="button"
                  :disabled="disabled"
                  :class="reseau.extensionOpportunite.visualiserCarteEdition ?
                  'is-primary' : 'is-grey'"
                  @click.prevent="$refs.checkBoxVisuCartoReseauNum.click()">
                  <b-icon icon="google-maps"/>
                </button>
              </div>
              <div class="media-content is-paddingless">
                <div class="content has-text-weight-semibold">
                  Afficher la cartographie
                </div>
                <input
                  type="checkbox"
                  v-model="reseau.extensionOpportunite.visualiserCarteEdition"
                  :disabled="disabled"
                  id="checkbox"
                  class="is-invisible"
                  ref="checkBoxVisuCartoReseauNum">
              </div>
            </article>
          </div>
          </div>
        </div>
      </div>
    <div class="control has-background-white">
      <label class="subtitle labelPeriode has-text-dark">Période</label>
      <div class="periode">
        <input class="input" @input="reseau.extensionOpportunite.periodeModifieManuellement=true"
               v-model="reseau.extensionOpportunite.periode"
               :disabled="disabled">
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/panier-mutation-type';
import inputCurrency from '@/components/general/inputCurrency';
import { calculTarifNet } from '@/services/calcul/calculTarif';
import { calculRemiseVenteRxNumerique } from '@/services/calcul/calculRemise';
import { RESEAU_NUMERIQUE } from '@/configuration/typesProduits';
import * as planningNumeriqueConf from '@/components/creationOpportunite/configuration/planningNumeriqueConf';
import infoWindowReseaux from './infoWindowReseaux';

const Panier = createNamespacedHelpers('panier');
const user = createNamespacedHelpers('user');

export default {
  name: 'reseaux-numerique',
  props: ['reseau', 'disabled'],
  data() {
    return {
      tarifications: planningNumeriqueConf.TYPE_TARIFICATION,
      isComponentDetailReseaux: false,
    };
  },
  components: {
    inputCurrency,
    infoWindowReseaux,
  },
  watch: {
    'reseau.extensionOpportunite.typeDeRemise': {
      handler() {
        this.changeTarifNet();
      },
      immediate: false,
    },
    'reseau.tarifBrut': {
      handler(value) {
        this.changeTarifNet(value);
      },
      immediate: false,
    },
  },
  computed: {
    ...user.mapGetters({
      isAffichageFaceEditionDefault: 'isAffichageFaceEditionDefault',
    }),
  },
  methods: {
    ...Panier.mapMutations({
      setRemoveProduit: types.REMOVE_PRODUIT_TYPE_RESEAU_NUMERIQUE,
    }),
    suppressionPanneau() {
      this.setRemoveProduit(this.reseau);
    },
    changeTarifNet(value, champTarifNet = false) {
      if (champTarifNet && this.reseau.tarifBrut) {
        calculRemiseVenteRxNumerique(this.reseau, value);
        return;
      }
      calculTarifNet(this.reseau, value, RESEAU_NUMERIQUE);
    },
    onRemiseChange(value) {
      let remise = value;
      if (!value) {
        remise = 0;
      }
      this.reseau.extensionOpportunite.remise = remise;
      this.changeTarifNet();
    },
  },
  mounted() {
    if (this.reseau.extensionOpportunite.masquerFaceEdition === null) {
      this.reseau.extensionOpportunite.masquerFaceEdition = !this.isAffichageFaceEditionDefault;
    }
  },
};
</script>

<style scoped>
  .inputFacesLc {
    padding-bottom:10px
  }
  .periode {
    padding: 5px 20px 5px 20px;
    background-color: #F2F7F9;
  }

  .labelPeriode {
    padding-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/reseauNumerique.vue